import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import logo from "../../../../assets/images/karak_logo_new.png";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
  mapUnits,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import showNotification from "../../../../helpers/show_notification";

const FreeGoodsReport = (props) => {
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [grandTotal, setGrandTotal] = useState(0);
  const [filterModalTotal, setFilterModalTotal] = useState(0);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [isLoadingBranchDetails, setIsLoadingBranchDetails] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const branchDetailsRequestId = useRef(0);
  const searchSigRef = useRef("");
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
  }, []);

  function afterFilter(newResult, newFilters) {
    //console.log(newResult);
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.receiving_cost),
      0,
    );
    setFilterModalTotal(total.toFixed(2));
  }
  function afterSearch(newResult, newFilters) {
    if (!newResult) return;
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.total_free_goods_cost),
      0,
    );
    const sig = `${newResult.length}:${Number(total.toFixed(2))}`;
    setFilteredOrders((prevOrders) => {
      if (searchSigRef.current === sig) return prevOrders;
      searchSigRef.current = sig;
      return newResult;
    });

    setGrandTotal(Number(total.toFixed(2)));
  }
  const [allOrders, setAllOrders] = useState([]);

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      setIsLoadingOrders(true);
      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_free_goods_report";
      const response = await postSubmitForm(url, {
        date_from: dateFrom,
        date_to: dateTo,
        summary_only: true,
      });
      if (requestId !== ordersRequestId.current) return;
      if (response && response.status === 1) {
        setAllOrders(response.data.branches || []);
        setGrandTotal(response.data.grand_total_free_goods_cost);
        setTablePage(1);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      showNotification(
        typeof error === "string"
          ? error
          : "Sorry! something went wrong, please contact our support team",
        "Error",
      );
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  const loadBranchFreeGoodsDetails = async (row) => {
    const requestId = ++branchDetailsRequestId.current;
    try {
      setSelectedRow({ ...row, item_details: row.item_details || [] });
      setSelectedBranch(row);
      setFilterModalTotal(row.total_free_goods_cost);
      setPoModal(true);
      if (row.item_details && row.item_details.length) {
        return;
      }
      setIsLoadingBranchDetails(true);
      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_free_goods_report";
      const response = await postSubmitForm(url, {
        date_from: dateFrom,
        date_to: dateTo,
        branch_id: row._id,
      });
      if (requestId !== branchDetailsRequestId.current) return;
      if (response && response.status === 1) {
        const branches = response.data.branches || [];
        const branch =
          branches.find((b) => String(b._id) === String(row._id)) ||
          branches[0];
        setSelectedRow(branch || { ...row, item_details: [] });
        if (branch) {
          setFilterModalTotal(branch.total_free_goods_cost);
        }
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      if (requestId !== branchDetailsRequestId.current) return;
      console.log(error);
    } finally {
      if (requestId === branchDetailsRequestId.current) {
        setIsLoadingBranchDetails(false);
      }
    }
  };

  const [orderStatus, setOrderStatus] = useState("All");
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    if (allOrders.length > 0) {
      if (orderStatus === "All") {
        setFilteredOrders([...allOrders]);
      } else {
        let arr = allOrders.filter((order) => order.status === orderStatus);
        setFilteredOrders(arr);
      }
    }
  }, [allOrders, orderStatus]);

  const [purchaseDetailsModal, setPurchaseDetailsModal] = useState(false);
  const [purchaseDetails, setPurchaseDetails] = useState([]);
  const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
  const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);
  const loadPurchaseDetails = async (item_id) => {
    try {
      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary_po";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        is_requested: false,
        item_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data.filter(
          (item) => item.delivery_details && item.delivery_details.is_free,
        );
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { delivery_details } = item;
          const {
            projected_cost = 0,
            unit_levels,
            receive,
          } = delivery_details || {};

          totalReceivingCost += Number(projected_cost);

          if (unit_levels && receive) {
            const convertedQty = convertToLowestUnit(unit_levels, receive);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.delivery_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setPurchaseDetails(data);
        setPurchaseDetailsModal(!purchaseDetailsModal);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [poModal, setPoModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);

  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
    },

    {
      dataField: "total_free_goods_cost",
      text: props.t("Projected Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadBranchFreeGoodsDetails(row);
            }}
          >
            {row.total_free_goods_cost}
          </span>
        );
      },

      style: { cursor: "pointer" },
    },
  ];

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      // formatter: (cell, row, rowIndex) => {
      //   return (
      //     <span
      //       className="text-info mr-2"
      //       title="View Details"
      //       style={{ cursor: "pointer" }}
      //       onClick={() => {
      //         loadPurchaseDetails(row.item_id);
      //       }}
      //     >
      //       {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
      //       </span>
      //   );
      // },
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      text: props.t("Purchasing Unit"),
      dataField: "unit_for_po",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "receive",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return <>{formatUnitsForReport(row.total_quantity)}</>;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "free_cost_price",
      text: props.t("Projected Price (QR)"),
      formatter: (cell, row) => {
        // return row?.price + "/" + row?.unit_for_po
        return row?.free_cost_price;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      dataField: "projected_cost",
      text: props.t("Projected Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    // {
    //   dataField: "receiving_date",
    //   text: props.t("Date"),
    //   formatter: (cell, row) => {
    //     return moment(row.receiving_date).format("DD/MM/YYYY HH:mm");
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "12%" };
    //   },
    //     },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "Free_Goods_Report";
    const exportType = "xls";

    let data_to_export = filteredOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Name: v.name,
          Projected_cost: v.total_free_goods_cost,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const columnsPurchaseDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "delivery_details.seq_no",
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "delivery_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "delivery_details.unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "delivery_details.unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.delivery_details?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivery_details.receive);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    // {
    //   dataField: "delivery_details.is_free",
    //   text: props.t("Free ?"),
    //   sort: false,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "6%" };
    //   },
    //   formatter: (cell) => (cell ? "Yes" : "No"),
    //   filter: selectFilter({
    //     options: [
    //       { value: true, label: "Yes" },
    //       { value: false, label: "No" },
    //     ],
    //     placeholder: "All",
    //   }),
    // },
    {
      dataField: "delivery_details.cost_price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.delivery_details.cost_price + "/" + row?.delivery_details?.unit_for_po
      //  },
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return row?.delivery_details?.free_cost_price;
        } else {
          return row?.delivery_details?.cost_price;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "delivery_details.receiving_cost",
      text: props.t("Receiving Cost"),
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.delivery_details?.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.delivery_details?.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "receiving_datetime",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.receiving_datetime).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Free Goods Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Free Goods Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Received Free Goods Report")} <br />
                      {/* <h6>
                        (PO Costing Report : PO created by CSM for branch + PO
                        Created by branch.)
                      </h6> */}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders && allOrders}
                      columns={columns_external}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                                delay={500}
                                onSearch={(searchText) => {
                                  if (!searchText || searchText.trim() === "") {
                                    toolkitProps.searchProps.onSearch(
                                      searchText,
                                    );
                                    afterSearch(toolkitProps.baseProps.data);
                                    return;
                                  }
                                  if (searchText?.length <= 3) return;
                                  const searchResult =
                                    toolkitProps.baseProps.data?.filter(
                                      (row) => {
                                        const matchesSearch = (value) => {
                                          if (
                                            value === null ||
                                            value === undefined
                                          )
                                            return false;
                                          if (typeof value === "object") {
                                            return Object.values(value).some(
                                              (v) => matchesSearch(v),
                                            );
                                          }
                                          return String(value)
                                            .toLowerCase()
                                            .includes(searchText.toLowerCase());
                                        };
                                        return Object.values(row).some(
                                          matchesSearch,
                                        );
                                      },
                                    );

                                  toolkitProps.searchProps.onSearch(searchText);
                                  afterSearch(searchResult);
                                }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}>
                              <h5>
                                {" "}
                                Projected Grand Total : QR{" "}
                                {grandTotal.toLocaleString("en-QA", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </h5>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            filter={filterFactory({ afterSearch })}
                            condensed
                            rowStyle={rowStyle}
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal size="xl" isOpen={poModal} toggle={() => setPoModal(!poModal)}>
            <ModalHeader toggle={() => setPoModal(!poModal)}>
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv1");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv1">
                <Col lg={4}>
                  <img
                    src={logo}
                    alt=""
                    height="50"
                    style={{ borderRadius: "5px" }}
                  />
                </Col>
                <Col lg={12}>
                  <CardTitle className="text-center">
                    {props.t("Free Goods Details")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            {" "}
                            Branch: {selectedRow.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="item_id"
                            data={selectedRow.item_details || []}
                            columns={columns}
                            striped
                            hover
                            condensed
                            filter={filterFactory({ afterFilter })}
                            rowStyle={rowStyle}
                            noDataIndication={
                              isLoadingBranchDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/* Purchase breakup details modal       */}
          <Modal
            size="xl"
            isOpen={purchaseDetailsModal}
            toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
          >
            <ModalHeader
              toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivPurchaseitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivPurchaseitem">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Free Goods Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>

                  <CardTitle className="text-center">
                    {props.t("(Item Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={purchaseDetails && purchaseDetails}
                            columns={columnsPurchaseDetails}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory()}
                            condensed
                            rowStyle={rowStyle}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(FreeGoodsReport)),
);
